<template>
  <div>
    <div class="closed-tp">
      <div data-bs-toggle="collapse" role="button" data-bs-target="#collapse-1" aria-expanded="false" aria-controls="collapse-1" @click="visibleClosed = !visibleClosed">
        <h6 class="mb-0">
          <font-awesome-icon icon="check-circle" />
          {{ $t("tp.closed-tp-title") }}
          <font-awesome-icon icon="angle-down" v-if="visibleClosed" />
          <font-awesome-icon icon="angle-right" v-if="!visibleClosed" />
        </h6>
      </div>
      <div id="collapse-1" class="collapse">
        <div class="m-2">
          <div class="workplanned-table b-table-sticky-header table-responsive-sm">
            <table class="table b-table table-hover table-bordered table-sm">
              <thead class="thead-dark text-center">
                <tr>
                  <th
                    v-for="field in fields"
                    :key="field.key"
                    @click="sortTpClosedTable(field.key)"
                  >
                    {{ field.label }}
                    <font-awesome-icon icon="sort" v-if="field.sortable" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="listWorkplannedClosed.length === 0" class="text-center">
                  {{ $t('tp.no-tp-closed') }}
                </tr>
                <tr v-for="item in listWorkplannedClosed" :key="item" class="text-center">
                  <td v-for="field in fields" :key="field.key">
                    <span v-if="field.key === 'departments'">
                      <span
                        v-for="department in item[field.key]"
                        :key="department"
                        class="display-nra-department m-1"
                      >
                        {{ department }}
                      </span>
                    </span>
                    <span v-else-if="field.key === 'nras'">
                      <span
                        v-for="nra in item[field.key]"
                        :key="nra"
                        class="display-nra-department m-1"
                      >
                        <span class="badge badge-secondary">
                          {{ nra }}
                        </span>
                      </span>
                    </span>
                    <span v-else-if="field.key === 'duration'">
                      <span v-if="item[field.key]">
                        {{ formatDuration(item[field.key]) }}
                      </span>
                    </span>
                    <span v-else-if="field.key === 'dateBegin'">
                      {{ formatDate(item[field.key]) }}
                    </span>
                    <span v-else-if="field.key === 'dateEnd'">
                      {{ formatDate(item[field.key]) }}
                    </span>
                    <span v-else-if="field.key === 'fallback'">
                      <span v-if="item[field.key]">
                        {{ $t(`tp.fallback.${item[field.key]}`) }}
                      </span>
                      <div v-if="item[field.key]" class="fallback-detail">
                        <p>
                          <span>{{ $t("tp.fallback-date-begin") }}</span>
                          <span>{{ formatDate(item[field.key].fallbackDateBegin) }}</span>
                        </p>
                        <p>
                          <span>{{ $t("tp.fallback-date-end") }}</span>
                          <span>{{ formatDate(item[field.key].fallbackDateEnd) }}</span>
                        </p>
                      </div>
                    </span>
                    <span v-else-if="field.key === 'description'">
                      <pre class="description-cell">{{ item[field.key] }}</pre>
                    </span>
                    <span v-else-if="field.key === 'impact'">
                      <pre class="description-cell">{{ item[field.key] }}</pre>
                    </span>
                    <span v-else>
                      {{ item[field.key] }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="current-tp">
      <h6 class="mb-0">
        <font-awesome-icon icon="exclamation-triangle" />
        {{ $t("tp.current-tp-title") }}
      </h6>

      <div class="m-2">
        <div class="workplanned-table b-table-sticky-header table-responsive-sm">
          <table class="table b-table table-bordered table-sm">
            <thead class="thead-dark text-center">
              <tr>
                <th
                  v-for="field in fields"
                  :key="field.key"
                  @click="sortTpCurrentTable(field.key)"
                >
                  {{ field.label }}
                  <font-awesome-icon icon="sort" v-if="field.sortable" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="listWorkplannedCurrent.length === 0" class="text-center">
                {{ $t('tp.no-tp-current') }}
              </tr>
              <tr v-for="item in listWorkplannedCurrent" :key="item" class="text-center">
                <td v-for="field in fields" :key="field.key">
                  <span v-if="field.key === 'departments'">
                    <span
                      v-for="department in item[field.key]"
                      :key="department"
                      class="display-nra-department m-1"
                    >
                      {{ department }}
                    </span>
                  </span>
                  <span v-else-if="field.key === 'nras'">
                    <span
                      v-for="nra in item[field.key]"
                      :key="nra"
                      class="display-nra-department m-1"
                    >
                      <span class="badge badge-secondary">
                        {{ nra }}
                      </span>
                    </span>
                  </span>
                  <span v-else-if="field.key === 'duration'">
                    <span v-if="item[field.key]">
                      {{ formatDuration(item[field.key]) }}
                    </span>
                  </span>
                  <span v-else-if="field.key === 'dateBegin'">
                    {{ formatDate(item[field.key]) }}
                  </span>
                  <span v-else-if="field.key === 'dateEnd'">
                    {{ formatDate(item[field.key]) }}
                  </span>
                  <span v-else-if="field.key === 'fallback'">
                    <span v-if="item[field.key]">
                      {{ $t(`tp.fallback.${item[field.key]}`) }}
                    </span>
                    <div v-if="item[field.key]" class="fallback-detail">
                      <p>
                        <span>{{ $t("tp.fallback-date-begin") }}</span>
                        <span>{{ formatDate(item[field.key].fallbackDateBegin) }}</span>
                      </p>
                      <p>
                        <span>{{ $t("tp.fallback-date-end") }}</span>
                        <span>{{ formatDate(item[field.key].fallbackDateEnd) }}</span>
                      </p>
                    </div>
                  </span>
                  <span v-else-if="field.key === 'description'">
                    <pre class="description-cell">{{ item[field.key] }}</pre>
                  </span>
                  <span v-else-if="field.key === 'impact'">
                    <pre class="description-cell">{{ item[field.key] }}</pre>
                  </span>
                  <span v-else>
                    {{ item[field.key] }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="future-tp">
      <div data-bs-toggle="collapse" role="button" data-bs-target="#collapse-2" aria-expanded="false" aria-controls="collapse-2" @click="visibleFuture = !visibleFuture">
        <h6 class="mb-0">
          <font-awesome-icon icon="check-circle" />
          {{ $t("tp.future-tp-title") }}
          <font-awesome-icon icon="angle-down" v-if="visibleFuture" />
          <font-awesome-icon icon="angle-right" v-if="!visibleFuture" />
        </h6>
      </div>
      <div id="collapse-2" class="collapse">
        <div class="m-2">
          <div class="workplanned-table b-table-sticky-header table-responsive-sm">
            <table class="table b-table table-hover table-bordered table-sm">
              <thead class="thead-dark text-center">
                <tr>
                  <th
                    v-for="field in fields"
                    :key="field.key"
                    @click="sortTpFutureTable(field.key)"
                  >
                    {{ field.label }}
                    <font-awesome-icon icon="sort" v-if="field.sortable" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="listWorkplannedFuture.length === 0" class="text-center">
                  {{ $t('tp.no-tp-future') }}
                </tr>
                <tr v-for="item in listWorkplannedFuture" :key="item" class="text-center">
                  <td v-for="field in fields" :key="field.key">
                    <span v-if="field.key === 'departments'">
                      <span
                        v-for="department in item[field.key]"
                        :key="department"
                        class="display-nra-department m-1"
                      >
                        {{ department }}
                      </span>
                    </span>
                    <span v-else-if="field.key === 'nras'">
                      <span
                        v-for="nra in item[field.key]"
                        :key="nra"
                        class="display-nra-department m-1"
                      >
                        <span class="badge badge-secondary">
                          {{ nra }}
                        </span>
                      </span>
                    </span>
                    <span v-else-if="field.key === 'duration'">
                      <span v-if="item[field.key]">
                        {{ formatDuration(item[field.key]) }}
                      </span>
                    </span>
                    <span v-else-if="field.key === 'dateBegin'">
                      {{ formatDate(item[field.key]) }}
                    </span>
                    <span v-else-if="field.key === 'dateEnd'">
                      {{ formatDate(item[field.key]) }}
                    </span>
                    <span v-else-if="field.key === 'fallback'">
                      <span v-if="item[field.key]">
                        {{ $t(`tp.fallback.${item[field.key]}`) }}
                      </span>
                      <div v-if="item[field.key]" class="fallback-detail">
                        <p>
                          <span>{{ $t("tp.fallback-date-begin") }}</span>
                          <span>{{ formatDate(item[field.key].fallbackDateBegin) }}</span>
                        </p>
                        <p>
                          <span>{{ $t("tp.fallback-date-end") }}</span>
                          <span>{{ formatDate(item[field.key].fallbackDateEnd) }}</span>
                        </p>
                      </div>
                    </span>
                    <span v-else-if="field.key === 'description'">
                      <pre class="description-cell">{{ item[field.key] }}</pre>
                    </span>
                    <span v-else-if="field.key === 'impact'">
                      <pre class="description-cell">{{ item[field.key] }}</pre>
                    </span>
                    <span v-else>
                      {{ item[field.key] }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { sortBy } from 'lodash';

export default {
  name: "WorkplannedView",
  props: {
    workplannedList: Array,
  },
  data() {
    return {
      listWorkplanned: [],
      fields: [
        {
          key: "departments",
          label: this.$t("tp.table.departments"),
          sortable: true,
        },
        { key: "nras", label: this.$t("tp.table.nra"), sortable: true },
        {
          key: "interventionType",
          label: this.$t("tp.table.intervention-type"),
        },
        { key: "technology", label: this.$t("tp.table.technology") },
        { key: "description", label: this.$t("tp.table.description") },
        {
          key: "dateBegin",
          label: this.$t("tp.table.date-begin"),
          sortable: true,
        },
        { key: "dateEnd", label: this.$t("tp.table.date-end"), sortable: true },
        { key: "duration", label: this.$t("tp.table.duration") },
        { key: "zone", label: this.$t("tp.table.zone"), sortable: true },
        { key: "fallback", label: this.$t("tp.table.fallback") },
        { key: "impact", label: this.$t("tp.table.impact") },
      ],
      sortCurrentBy: "dateBegin",
      sortCurrentDesc: false,
      listWorkplannedClosed: [],
      listWorkplannedCurrent: [],
      listWorkplannedFuture: [],
      visibleFuture: false,
      visibleClosed: false,
      sortClosedBy: "dateBegin",
      sortClosedDesc: false,
      sortFutureBy: "dateBegin",
      sortFutureDesc: false,
    };
  },
  created() {
    this.loadWorkplannedList();
  },
  methods: {
    loadWorkplannedList() {
      this.listWorkplanned = this.workplannedList;
      this.listWorkplannedClosed = [];
      this.listWorkplannedCurrent = [];
      this.listWorkplannedFuture = [];
      const currentTimestamp = Date.now();

      this.listWorkplanned.forEach((work) => {
        if (work.technology === "FIBRE_OPTIQUE") {
          work.urgent = true;
        }

        // Remove duplicate departments for the same workplanned
        work.departments = work.departments.filter((v, i) => work.departments.indexOf(v) === i);

        const timestampStart = new Date(
          work.dateBegin.replace(" ", "T")
        ).getTime();
        const timestampEnd = new Date(work.dateEnd.replace(" ", "T")).getTime();

        if (
          timestampStart < currentTimestamp &&
          timestampEnd > currentTimestamp
        ) {
          work.isToday = false;
          work.isNow = true;
          this.listWorkplannedCurrent.push(work);
        } else if (
          timestampStart > currentTimestamp &&
          timestampStart - 24 * 60 * 60 * 1000 < currentTimestamp
        ) {
          work.isToday = true;
          this.listWorkplannedCurrent.push(work);
        } else if (
          timestampEnd < currentTimestamp &&
          timestampEnd + 24 * 60 * 60 * 1000 > currentTimestamp
        ) {
          work.isYesterday = true;
          this.listWorkplannedClosed.push(work);
        } else if (timestampEnd < currentTimestamp) {
          this.listWorkplannedClosed.push(work);
        } else {
          this.listWorkplannedFuture.push(work);
        }
      });
    },

    formatDate(date) {
      if (!date) {
        return "";
      }
      const timestamp = new Date(date.replace(" ", "T")).getTime();
      return moment(timestamp).format("DD/MM/YYYY à HH:mm:ss");
    },

    formatDuration(duration) {
      if (duration.startsWith('PT')) {
        const durationValue = duration.split('PT')[1];
        if (durationValue.indexOf('H') !== -1) {
          return this.$t('tp.duration.hours', {nbHours: durationValue.substring(0, durationValue.indexOf('H'))});
        } else if (durationValue.indexOf('D') !== -1) {
          return this.$t('tp.duration.days', {nbHours: durationValue.substring(0, durationValue.indexOf('D'))});
        }
      }
      return duration;
    },
    sortTpClosedTable(col) {
      const sortList = sortBy(this.listWorkplannedClosed, col);
      this.listWorkplannedClosed = sortList;
    },
    sortTpCurrentTable(col) {
      const sortList = sortBy(this.listWorkplannedCurrent, col);
      this.listWorkplannedCurrent = sortList;
    },
    sortTpFutureTable(col) {
      const sortList = sortBy(this.listWorkplannedFuture, col);
      this.listWorkplannedFuture = sortList;
    },
  },
  watch: {
    workplannedList() {
      this.loadWorkplannedList();
    },
  },
};
</script>

<style>
.current-tp {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 1rem;
  text-align: left;
  margin: 1rem;
}
.closed-tp {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 1rem;
  text-align: left;
  margin: 1rem;
}
.future-tp {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 1rem;
  text-align: left;
  margin: 1rem;
}
.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
  vertical-align: top;
}
.table-bordered thead td,
.table-bordered thead th {
  border-bottom-width: 2px;
}
.workplanned-table {
  font-size: 0.9rem;
}
.fallback-detail {
  font-size: 0.8rem;
  width: 160px;
}
.description-cell {
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: justify;
  font-size: 0.75rem;
  font-weight: normal;
  padding: 9.5px;
  margin: 0 0 10px;
  line-height: 1.428571429;
  word-break: break-all;
  color: #333;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.future-table {
  font-size: 0.9rem;
  height: 90vh;
  max-height: 90vh !important;
}
</style>